import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function AuditoriaDeDespachos() {
  return (
    <ClipperPlaceholder title="Auditoría de Despachos" category="Operativas" />
  );
}
